import {
    ZasilkovnaCarrierAddressesType,
    ZasilkovnaCarriersAddressesResType,
    ZasilkovnaCarriersCarriersResType,
    ZasilkovnaCarrierType,
} from 'src/types/zasilkovna';

export const formatDataCarriers = (data: ZasilkovnaCarriersCarriersResType[]): ZasilkovnaCarrierType[] => {
    return data
        .map((item: any): any => {
            return { label: item.LABEL_NAME, value: String(item.CARRIER_ID) };
        })
        .sort((a: any, b: any): any => `${a.label}`.localeCompare(`${b.label}`));
};
export const formatDataCarriersAddress = (
    data: ZasilkovnaCarriersAddressesResType[]
): ZasilkovnaCarrierAddressesType => {
    const carriersAddress: ZasilkovnaCarrierAddressesType = {};

    data.forEach((item: any) => {
        carriersAddress[item.id] = item.points.map((point: any): any => ({
            label: `${point.city}, ${point.street}${point.streetNumber ? ` ${point.streetNumber}` : ''}`,
            value: point.code,
        }));
    });

    return carriersAddress;
};

// Map Packeta/Zásilkovna points to options without additional UI-side filtering.
export const formatPCKTData = (data: any) => {
    return Object.keys(data)
        .map((item: any): any => {
            return { label: data[item].name, value: data[item].id };
        })
        .sort((a: any, b: any): any => `${a.label}`.localeCompare(`${b.label}`));
};

// Check if carrier has pickup points enabled
export const hasPickupPoints = (
    carriersRaw: ZasilkovnaCarriersCarriersResType[] | null,
    carrierId: string | number | null | undefined
): boolean => {
    if (!carriersRaw || !carrierId) {
        return false;
    }
    const carrier = carriersRaw.find((c) => String(c.CARRIER_ID) === String(carrierId));
    return carrier?.PICKUP_POINTS ?? false;
};
